/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Why_DeletingInputs */

const en_dialog_why_deleting = /** @type {(inputs: Dialog_Why_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are you deleting your account?`)
};

const es_dialog_why_deleting = /** @type {(inputs: Dialog_Why_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué estás eliminando tu cuenta?`)
};

/**
* | output |
* | --- |
* | "Why are you deleting your account?" |
*
* @param {Dialog_Why_DeletingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_why_deleting = /** @type {((inputs?: Dialog_Why_DeletingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Why_DeletingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_why_deleting(inputs)
	return en_dialog_why_deleting(inputs)
});